import * as React from 'react';
import { SaveSearchCheckState, SaveSearchState, SearchParams as SearchParamsType } from '@/types/SaveSearch';
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import { ModalContext } from '@/redux/modules/modal';
import Popover from '@liveauctioneers/caterwaul-components/lib/Popover/Popover';
import ShouldLogInContainer from '@/components/ShouldLogIn/ShouldLogInContainer';
import styled from 'styled-components';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';

type Props = {
    allSearchParams?: SearchParamsType;
    className?: string;
    deleteSavedSearch: Function;
    primary: boolean;
    saveSearchCheckState: SaveSearchCheckState;
    //savesearchstate used for loading throbber,  not currently in use.
    saveSearchState?: SaveSearchState;
    small?: boolean;
    submitSaveSearch: Function;
    tooltipMessage?: React.ReactNode | string;
};

const SaveSearch = (props: Props) => {
    const {
        allSearchParams,
        className,
        deleteSavedSearch,
        primary,
        saveSearchCheckState,
        saveSearchState,
        small,
        submitSaveSearch,
        tooltipMessage,
    } = props;
    const { submitted } = saveSearchState;
    const { isSavedSearch } = saveSearchCheckState;

    const modalContext: ModalContext = {
        id: 0,
        type: 'follow search',
    };
    const nonSavedSearchButton = (
        <ShouldLogInContainer
            allSearchParams={allSearchParams}
            modalContext={modalContext}
            runFunction={submitSaveSearch}
        >
            <FollowButtonConfirm
                className={className}
                date-testid="nonSavedSearchButton"
                loading={submitted}
                primary={primary}
                small={small}
            >
                <StyledFontAwesomeIcon icon={faEnvelope} />
                <FormattedMessage id="follow_search" />
            </FollowButtonConfirm>
        </ShouldLogInContainer>
    );

    const nonSavedSearchButtonWithPopover = (
        <StyledPopoverContainer>
            <Popover hover placement="bottom" trigger={nonSavedSearchButton}>
                <StyledPopoverContent>
                    <Text id="popover" secondary>
                        {tooltipMessage}
                    </Text>
                </StyledPopoverContent>
            </Popover>
        </StyledPopoverContainer>
    );

    const renderContent = isSavedSearch ? (
        <ShouldLogInContainer requireLogin runFunction={deleteSavedSearch}>
            <FollowButton className={className} date-testid="isSavedSearchButton" loading={submitted} small={small}>
                <StyledFontAwesomeIcon icon={faCheck} />
                <FormattedMessage id="following_search" />
            </FollowButton>
        </ShouldLogInContainer>
    ) : tooltipMessage ? (
        nonSavedSearchButtonWithPopover
    ) : (
        nonSavedSearchButton
    );

    return renderContent;
};

export default React.memo<Props>(SaveSearch, isEqual);

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
    margin-right: 6px;
    height: 14px;
    width: 14px;
`;

const StyledPopoverContainer = styled.div`
    max-width: fit-content;
    line-height: 0;

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidthNum - 1}px) {
        max-width: none;
    }
`;

const FollowButton = styled(Button)`
    width: 195px;
`;

const FollowButtonConfirm = styled(FollowButton)``;

const StyledPopoverContent = styled.div`
    padding: 5px 10px;
    width: 256px;
    line-height: 1px;
`;
